import React, { useState } from "react";
import styles from "./style.module.scss";

interface Driver {
  carNum: string;
  name: string;
  team?: string;
  color?: string;
}

interface DriverSelectorProps {
  drivers: Driver[];
  onSelectionChange: (selectedDrivers: string[]) => void;
}

const DriverSelector: React.FC<DriverSelectorProps> = ({
  drivers,
  onSelectionChange,
}) => {
  const [selectedDrivers, setSelectedDrivers] = useState<string[]>([]);

  const handleDriverClick = (carNum: string) => {
    const newSelection = selectedDrivers.includes(carNum)
      ? selectedDrivers.filter((id) => id !== carNum)
      : [...selectedDrivers, carNum];

    setSelectedDrivers(newSelection);
    onSelectionChange(newSelection);
  };

  const handleSelectAll = () => {
    const allDrivers = drivers.map((driver) => driver.carNum);
    setSelectedDrivers(allDrivers);
    onSelectionChange(allDrivers);
  };

  const handleSelectNone = () => {
    setSelectedDrivers([]);
    onSelectionChange([]);
  };

  return (
    <div className={styles.driverSelector}>
      <div className={styles.selectorContainer}>
        <div className={styles.controlButtons}>
          <button className={styles.controlButton} onClick={handleSelectAll}>
            ALL
          </button>
          <button className={styles.controlButton} onClick={handleSelectNone}>
            NONE
          </button>
        </div>
        <div className={styles.driverList}>
          {drivers.map((driver) => {
            const driverColor = driver.color || "rgb(128, 128, 128)";
            // Check if the color is black or very dark
            const isBlackColor =
              driverColor === "rgb(0, 0, 0)" ||
              driverColor.toLowerCase().includes("rgb(0, 0, 0)");

            const isSelected = selectedDrivers.includes(driver.carNum);

            return (
              <button
                key={driver.carNum}
                className={`${styles.driverButton} ${
                  isSelected ? styles.selected : ""
                }`}
                style={{
                  backgroundColor: driverColor,
                  borderColor: "#000",
                  color: isBlackColor ? "#fff" : "#000",
                  borderWidth: isSelected ? "4px" : "2px",
                  borderStyle: "solid",
                  minHeight: isSelected ? "48px" : "40px",
                  padding: isSelected ? "8px 16px" : "6px 12px",
                  fontSize: isSelected ? "16px" : "14px",
                  fontWeight: isSelected ? "bold" : "normal",
                  transform: isSelected ? "scale(1.05)" : "scale(1)",
                  transition: "all 0.2s ease-in-out",
                }}
                onClick={() => handleDriverClick(driver.carNum)}
              >
                {driver.name}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DriverSelector;
